import ApiInfo from './ApiInfo.js'

class BzxtApiInfo extends ApiInfo {
    constructor({
        path,
        type = 'get',
        timeout = 10000,
        headers,
        project = 'tagging', // || qukan,
        author = '未定义'
    }) {
        super({
            path,
            type,
            timeout,
            headers,
            project,
            author
        })
    }
}

export default {
    user: {
        login: new BzxtApiInfo({
            path: '/user/login',
            type: 'get',
            author: '密勃祥'
        }),
        list: new BzxtApiInfo({
            path: '/user/getReadyAdminList',
            type: 'get',
            author: '密勃祥'
        })
    },
    mission: {
        getLog: new BzxtApiInfo({
            path: '/mission/getLog',
            type: 'get',
            author: '孙万成'
        }),
        list: new BzxtApiInfo({
            path: '/mission/list',
            type: 'get',
            author: '密勃祥'
        }),
        delete: new BzxtApiInfo({
            path: '/mission/delete',
            type: 'get',
            author: '密勃祥'
        }),
        add: new BzxtApiInfo({
            path: '/mission/add',
            type: 'post',
            author: '密勃祥'
        }),
        uploadCsv: new BzxtApiInfo({
            path: '/mission/uploadCsv',
            type: 'post',
            author: '密勃祥'
        }),
        detail: new BzxtApiInfo({
            path: '/mission/detail',
            type: 'get',
            author: '密勃祥'
        }),
        save: new BzxtApiInfo({
            path: '/mission/save',
            type: 'post',
            author: '密勃祥'
        }),
        publish: new BzxtApiInfo({
            path: '/mission/publish',
            type: 'get',
            author: '密勃祥'
        }),
        submitAnswer: new BzxtApiInfo({
            path: '/mission/submitAnswer',
            type: 'post',
            author: '密勃祥'
        }),
        getTaggingInfo: new BzxtApiInfo({
            path: '/mission/getTaggingInfo',
            type: 'get',
            author: '密勃祥'
        }),
        remotesearch: new BzxtApiInfo({
            path: '/QuestionApi/getOtherAnswerList',
            type: 'get',
            author: '孙万成'
        })
    },
    task: {
        follow: new BzxtApiInfo({
            path: '/task/follow',
            type: 'post',
            author: '孙万成'
        }),
        myFollow: new BzxtApiInfo({
            path: '/task/myFollow',
            type: 'get',
            author: '密勃祥'
        }),
        missionList: new BzxtApiInfo({
            path: '/task/missionList',
            type: 'get',
            author: '密勃祥'
        }),
        receiveTask: new BzxtApiInfo({
            path: '/task/receiveTask',
            type: 'get',
            author: '密勃祥'
        }),
        taskList: new BzxtApiInfo({
            path: '/task/taskList',
            type: 'get',
            author: '密勃祥'
        }),
        finishTask: new BzxtApiInfo({
            path: '/task/finishTask',
            type: 'get',
            author: '密勃祥'
        }),
        returnTagging: new BzxtApiInfo({
            path: '/task/returnTagging',
            type: 'get',
            author: '密勃祥'
        }),
        getReadyInfo: new BzxtApiInfo({
            path: '/task/getReadyInfo',
            type: 'get',
            author: '密勃祥'
        }),
        submitReadyAnswer: new BzxtApiInfo({
            path: '/task/submitReadyAnswer',
            type: 'post',
            author: '密勃祥'
        }),
        submitTaggingAnswer: new BzxtApiInfo({
            path: '/task/submitTaggingAnswer',
            type: 'post',
            author: '密勃祥'
        }),
        getTaggingInfo: new BzxtApiInfo({
            path: '/task/getTaggingInfo',
            type: 'get',
            author: '密勃祥'
        }),
        addReadyTaggingTask: new BzxtApiInfo({
            path: '/task/addReadyTaggingTask',
            type: 'get',
            author: '密勃祥'
        }),
        errorList: new BzxtApiInfo({
            path: '/task/errorList',
            type: 'get',
            author: '密勃祥'
        }),
        getErrorInfo: new BzxtApiInfo({
            path: '/task/getErrorInfo',
            type: 'get',
            author: '密勃祥'
        })
    },
    downloadTask: {
        addDownloadTask: new BzxtApiInfo({
            path: '/downloadTask/addDownloadTask',
            type: 'get',
            author: '密勃祥'
        }),
        downloadTaskList: new BzxtApiInfo({
            path: '/downloadTask/downloadTaskList',
            type: 'get',
            author: '密勃祥'
        }),
        downloadFile: new BzxtApiInfo({
            path: '/downloadTask/downloadFile',
            type: 'get',
            author: '密勃祥'
        })
    },
    training: {
        getNextTraining: new BzxtApiInfo({
            path: '/training/getNextTraining',
            type: 'post',
            author: '密勃祥'
        }),
        add: new BzxtApiInfo({
            path: '/training/add',
            type: 'get',
            author: '密勃祥'
        })
    },
    quality: {
        missionList: new BzxtApiInfo({
            path: '/quality/missionList',
            type: 'get',
            author: '密勃祥'
        }),
        missionInfo: new BzxtApiInfo({
            path: '/quality/missionInfo',
            type: 'get',
            author: '密勃祥'
        }),
        qualityErrorList: new BzxtApiInfo({
            path: '/quality/qualityErrorList',
            type: 'get',
            author: '密勃祥'
        }),
        crossErrorList: new BzxtApiInfo({
            path: '/quality/crossErrorList',
            type: 'get',
            author: '密勃祥'
        }),
        getTaggingInfo: new BzxtApiInfo({
            path: '/quality/getTaggingInfo',
            type: 'get',
            author: '密勃祥'
        }),
        crossErrorMissionList: new BzxtApiInfo({
            path: '/quality/crossErrorMissionList',
            type: 'get',
            author: '密勃祥'
        }),
        qualityErrorMissionList: new BzxtApiInfo({
            path: '/quality/qualityErrorMissionList',
            type: 'get',
            author: '密勃祥'
        }),
        getQualityErrorInfo: new BzxtApiInfo({
            path: '/quality/getQualityErrorInfo',
            type: 'get',
            author: '密勃祥'
        }),
        submitAnswer: new BzxtApiInfo({
            path: '/quality/submitAnswer',
            type: 'get',
            author: '密勃祥'
        }),
        returnMissionTagging: new BzxtApiInfo({
            path: '/quality/returnMissionTagging',
            type: 'get',
            author: '密勃祥'
        }),
        taskList: new BzxtApiInfo({
            path: '/quality/taskList',
            type: 'get',
            author: '密勃祥'
        }),
        qualityList: new BzxtApiInfo({
            path: '/quality/qualityList',
            type: 'get',
            author: '密勃祥'
        }),
        submitQualityAnswer: new BzxtApiInfo({
            path: '/quality/submitQualityAnswer',
            type: 'post',
            author: '密勃祥'
        }),
        getQualityInfo: new BzxtApiInfo({
            path: '/quality/getQualityInfo',
            type: 'get',
            author: '密勃祥'
        }),
        qcTaskList: new BzxtApiInfo({
            path: '/qualitynew/taskList',
            type: 'post',
            author: '张振胜'
        }),
        qcTaskDetail: new BzxtApiInfo({
            path: '/qualitynew/taskDataList',
            type: 'post',
            author: '张振胜'
        }),
        qcNewDetail: new BzxtApiInfo({
            path: '/qualitynew/detail',
            type: 'post',
            author: '张振胜'
        }),
        qcNewSubmit: new BzxtApiInfo({
            path: '/qualitynew/submit',
            type: 'post',
            author: '张振胜'
        }),
        qcReport: new BzxtApiInfo({
            path: '/report/addClick',
            type: 'post',
            author: '张振胜'
        })
    },
    cross: {
        getCrossErrorInfo: new BzxtApiInfo({
            path: '/cross/getCrossErrorInfo',
            type: 'get',
            author: '密勃祥'
        }),
        getMissionCrossInfo: new BzxtApiInfo({
            path: '/cross/getMissionCrossInfo',
            type: 'get',
            author: '密勃祥'
        })
    },
    admin: {
        getmissiondatalist: new BzxtApiInfo({
            path: '/mission/getmissiondatalist',
            type: 'get',
            author: '孙万成'
        }),
        getmissiondatainfo: new BzxtApiInfo({
            path: '/mission/getmissiondatainfo',
            type: 'get',
            author: '孙万成'
        }),
        reviewanswer: new BzxtApiInfo({
            path: '/mission/reviewanswer',
            type: 'post',
            author: '孙万成'
        }),
        endmission: new BzxtApiInfo({
            path: '/mission/endmission',
            type: 'post',
            author: '孙万成'
        })
    }
}



// WEBPACK FOOTER //
// ./src/core/Apis/Tagging.js